export class DriverDeviationFilter {
  constructor(
    public includeHandled?: boolean,
    public searchTerm?: string,
    public trafficDate?: Date
  ) {}
}
